
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ThematicfilesPage } from './thematicfiles';

const routes: Routes = [
  {
    path: ':newspaper',
    loadChildren: () => import('./thematicfilescat/thematicfilescat.module').then( m => m.ThematicfilescatModule)
  },
  {
    path: ':newspaper/:themeslug',
    loadChildren: () => import('./thematicfilessubcat/thematicfilessubcat.module').then( m => m.ThematicfilessubcatModule)
  },
  {
    path: ':newspaper/:themeslug/:slug',
    loadChildren: () => import('./thematicfiledetail/thematicfiledetail.module').then( m => m.ThematicfiledetailModule)
  },
  { path: '', component: ThematicfilesPage },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ThematicfileslRoutingModule {}
